/* FanArmor – team finder + FAQ */
(function () {
  if (window.__faLoaded) return;
  window.__faLoaded = true;

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
  }

  function initTeams(root) {
    if (root.dataset.faReady) return;
    root.dataset.faReady = '1';
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-team]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-div]'));
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-conf-btn]'));
    var input = root.querySelector('[data-team-search]');
    var none = root.querySelector('[data-team-none]');
    var conf = 'all';

    function apply() {
      var q = input ? norm(input.value) : '';
      var shown = 0;
      tiles.forEach(function (t) {
        var ok = (conf === 'all' || t.dataset.conf === conf) && (!q || t.dataset.name.indexOf(q) > -1);
        t.hidden = !ok;
        if (ok) shown++;
      });
      groups.forEach(function (g) {
        g.hidden = !g.querySelector('[data-team]:not([hidden])');
      });
      if (none) none.hidden = shown > 0;
    }

    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        conf = b.dataset.confBtn;
        btns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        apply();
      });
    });
    if (input) input.addEventListener('input', apply);
  }

  function initFaq(root) {
    if (root.dataset.faReady || root.dataset.single !== 'true') return;
    root.dataset.faReady = '1';
    var items = root.querySelectorAll('details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return;
        items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-fa-teams]').forEach(initTeams);
    document.querySelectorAll('[data-fa-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
